import React from 'react';
import { ProductsListItem } from './ProductsListItem';
import * as S from './styled';
export const ProductsList = ({ size = 'small', children }) => (React.createElement(S.Container, { size: size },
    React.createElement("tbody", null, React.Children.map(children, (child) => child && React.cloneElement(child, { size })))));
ProductsList.Item = ProductsListItem;
